import { HouseType } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/House/houseTypes";
import { TextManager } from "Components/TextContext";
import { OptionLabel } from "Components/TextContext/commonComponentEnums";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { HouseProduct } from "Store/interfaces/products/checkout/riskProducts/houseProducts/HouseProduct";
import { ProductDetail } from "../interface";
import { akaCriticalIllnessDetailsList } from "./LifeProducts/AkaCriticalIllnessDetailsList";
import { akaGroupLifeDetailsList } from "./LifeProducts/AkaGroupLifeDetailsList";
import { disabilityDetailsList } from "./LifeProducts/DisabilityDetailsList";
import { healthWithoutSigningDetailsList } from "./LifeProducts/HealthWithoutSigningDetailsList";
import { sopSicknessLeaveDetailsList } from "./LifeProducts/SopSicknessLeaveDetailsList";
import { accidentDetailsList } from "./RiskProducts/AccidentDetailsList";
import { akaStudentDetailsList } from "./RiskProducts/AkaStudentDetailsList";
import { akaTravelDetailsList } from "./RiskProducts/AkaTravelDetailsList";
import { animalDetailsList } from "./RiskProducts/AnimalDetailsList";
import { boatDetailList } from "./RiskProducts/BoatDetailsList";
import { caravanDetailsList } from "./RiskProducts/CaravanDetailsList";
import { akaHouseContentsDetailsList } from "./RiskProducts/HouseProducts/AkaHouseContentsDetailsList";
import { cabinContentsDetailsList } from "./RiskProducts/HouseProducts/CabinContentsDetailsList";
import { cabinDetailsList } from "./RiskProducts/HouseProducts/CabinDetailsList";
import { houseContentsDetailsList } from "./RiskProducts/HouseProducts/HouseContentsDetailsList";
import { houseDetailsList } from "./RiskProducts/HouseProducts/HouseDetailsList";
import { huseierneHouseContentsDetailsList } from "./RiskProducts/HouseProducts/HuseierneHouseContentsDetailsList";
import { rentalDetailsList } from "./RiskProducts/HouseProducts/RentalDetailsList";
import { trailerDetailsList } from "./RiskProducts/TrailerDetailsList";
import { travelDetailsList } from "./RiskProducts/TravelDetailsList";
import { valuablesDetailsList } from "./RiskProducts/ValuablesDetailsList";
import { carDetailsList } from "./RiskProducts/VehicleProducts/CarDetailsList";
import { carNorskElbilforeningDetailsList } from "./RiskProducts/VehicleProducts/CarNorskElbilforeningDetailsList";
import { electricScooterDetailsList } from "./RiskProducts/VehicleProducts/ElectricScooterDetailsList";
import { mopedDetailsList } from "./RiskProducts/VehicleProducts/MopedDetailsList";
import { motorcycleDetailsList } from "./RiskProducts/VehicleProducts/MotorcycleDetailsList";
import { tractorDetailsList } from "./RiskProducts/VehicleProducts/TractorDetailsList";
import { veteranAutoDetailsList } from "./RiskProducts/VehicleProducts/VeteranAutoDetailsList";

export const getProductDetailsList = (
  product: InsuranceProduct,
  types: any,
  lang: string,
  urls: Record<string, string>,
  featureToggleGeodata: boolean,
): ProductDetail[] => {
  switch (product.name) {
    case INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT:
    case INSURANCE_NAME_VALUE.AKA_HEALTH:
    case INSURANCE_NAME_VALUE.AKA_HEALTH_WITHOUT_SIGNING:
    case INSURANCE_NAME_VALUE.AKA_CHILD:
    case INSURANCE_NAME_VALUE.NEW_CHILD:
    case INSURANCE_NAME_VALUE.CHILD_HEALTH:
    case INSURANCE_NAME_VALUE.HEALTH:
    case INSURANCE_NAME_VALUE.CRITICAL_ILLNESS:
    case INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN:
    case INSURANCE_NAME_VALUE.DEATH:
      return [];
    case INSURANCE_NAME_VALUE.ACCIDENT:
      return accidentDetailsList(product, urls);
    case INSURANCE_NAME_VALUE.AKA_CRITICAL_ILLNESS:
      return akaCriticalIllnessDetailsList(product, types);
    case INSURANCE_NAME_VALUE.AKA_STUDENT:
      return akaStudentDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.AKA_TRAVEL:
      return akaTravelDetailsList(product, types, lang, urls);
    case INSURANCE_NAME_VALUE.ANIMAL:
      return animalDetailsList(product, urls);
    case INSURANCE_NAME_VALUE.BOAT:
      return boatDetailList(product, types, lang);
    case INSURANCE_NAME_VALUE.CABIN:
      return cabinDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.CABIN_CONTENTS:
      return cabinContentsDetailsList(product);
    case INSURANCE_NAME_VALUE.CAR:
      return carDetailsList(product, types);
    case INSURANCE_NAME_VALUE.CAR_NORSK_ELBILFORENING:
      return carNorskElbilforeningDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.DISABILITY_FLEX:
      return disabilityDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER:
      return electricScooterDetailsList(product);
    case INSURANCE_NAME_VALUE.HOUSE:
      return houseDetailsList(product, featureToggleGeodata);
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
      return akaHouseContentsDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.HOUSE_CONTENTS:
      return houseContentsDetailsList(product);
    case INSURANCE_NAME_VALUE.RENTAL:
      return rentalDetailsList(product);
    case INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE:
      return sopSicknessLeaveDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.TRAILER:
      return trailerDetailsList(product);
    case INSURANCE_NAME_VALUE.TRAVEL:
      return travelDetailsList(product, types, lang, urls);
    case INSURANCE_NAME_VALUE.VALUABLES:
      return valuablesDetailsList(product, types, lang, urls);
    case INSURANCE_NAME_VALUE.VETERAN_AUTO:
      return veteranAutoDetailsList(product, urls);
    case INSURANCE_NAME_VALUE.TRACTOR:
      return tractorDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.CARAVAN:
      return caravanDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.MOPED:
      return mopedDetailsList(product);
    case INSURANCE_NAME_VALUE.MOTORCYCLE:
      return motorcycleDetailsList(product, types, lang);
    case INSURANCE_NAME_VALUE.AKA_GROUP_LIFE:
      return akaGroupLifeDetailsList(product);
    case INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS:
      return huseierneHouseContentsDetailsList(product);
    case INSURANCE_NAME_VALUE.CHILD:
      return defaultDetailsTable();
    case INSURANCE_NAME_VALUE.HEALTH_WITHOUT_SIGNING:
      return healthWithoutSigningDetailsList(product);
    default:
      return defaultDetailsTable();
  }
};

const defaultDetailsTable = (): any => [
  {
    name: "deductible",
    value: "hei",
  },
  {
    name: "coverageAmount",
    value: "på",
  },
  {
    name: "insurance",
    value: "deg",
  },
  {
    name: "boatType",
    value: "din gamle seig",
  },
];

export const getHouseTypeDetail = (houseType: HouseType): string => {
  const { getText } = TextManager;

  switch (houseType) {
    case HouseType.DETACHED_HOUSE:
      return getText("houseform.optionlabel.1-housetype-detached");
    case HouseType.UNDETACHED_HOUSE:
      return getText("houseform.optionlabel.2-housetype-townhouse");
    case HouseType.SEMI_DETACHED_HOUSE:
      return getText("houseform.optionlabel.3-housetype-vertical");
    case HouseType.SEMI_DETACHED_HOUSE_HORIZONTAL:
      return getText("houseform.optionlabel.4-housetype-horizontal");
    default:
      return "";
  }
};

export const getYesOrNoText = (value = false): string => {
  const { getText } = TextManager;
  return value
    ? getText(OptionLabel.BOOLEAN_YES)
    : getText(OptionLabel.BOOLEAN_NO);
};

export const getRentalStatusProductDetail = (
  product: HouseProduct,
): ProductDetail => {
  const { getText } = TextManager;

  if (product.hasPartialRental) {
    return {
      name: getText("houseform.shorttitle.partialrental"),
      value: getText(OptionLabel.BOOLEAN_YES),
    };
  } else if (product.hasRental) {
    return {
      name: getText("houseform.shorttitle.fullrental"),
      value: getText(OptionLabel.BOOLEAN_YES),
    };
  }

  return {
    name: getText("houseform.shorttitle.norental"),
    value: getText(OptionLabel.BOOLEAN_NO),
  };
};
